import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Questions } from 'src/app/common-class/questions';
import { Group } from 'src/app/common-class/pages';
import { Answers } from 'src/app/common-class/answers';
import { AnswerImage } from 'src/app/common-class/answer-image';
import { AnswerMedia } from 'src/app/common-class/answer-media';
import { CommonLogic } from 'src/app/common-logic/common-logic'
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
declare var $: any;

@Component({
  selector: 'app-symbol-rating-scale',
  templateUrl: './symbol-rating-scale.component.html',
  styleUrls: ['./symbol-rating-scale.component.css'],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class SymbolRatingScaleComponent implements OnInit {

  @Input() JsonData: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Input() isDisplaySubQno: boolean;
  @Input() group: Group;
  @Input() isMobile: boolean;
  @Input() isNewParticipationButton: boolean;

  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();

  questions: Questions[];
  imgQuestion: Questions;
  firstQuestion:Questions;
  isMandatory: boolean;
  _isMandatoryInvalid: boolean;
  isFormSubmit: boolean = false;
  isFormSubmitSub: any;
  isDisplaySubQNo: boolean = false;
  isPreview: boolean = false;
  isNewParticipation: boolean;
  surveyFormat:number = 0;
  newParticipationBtnText: string;
  showNewParticipationButton: any;
  isAnsChange: boolean = false;
  isNgOnChange: boolean;
  count: number = 0;
  isPreReadQn: boolean;
  resetPageSub: any;

  ngOnChanges(changes: SimpleChanges) {

    let change = changes['JsonData'];

    let curVal = JSON.stringify(change.currentValue);
    let preVal = JSON.stringify(change.previousValue);

    if (curVal != preVal && preVal != undefined) {
      this.questions = JSON.parse(this.JsonData);
      this.isNgOnChange = true;
      this.count = 0;
      if (this.group.answer_style == 1) {
        this.questions = CommonLogic.RandomQuestionsHandling(this.questions);
      }
      else if(this.group.answer_style == 0 && this.questions.length > 1)
      {
      this.questions.sort((n1, n2) => n1.sub_qno - n2.sub_qno);
      }
      else if(this.group.answer_style == 2 && this.questions[0].grpRotateIndex != -1 && this.questions.length > 1)
      {
        this.questions.sort((n1, n2) => n1.sub_qno - n2.sub_qno);
        CommonLogic.RotateQuestionsHandling(this.questions);
      }

      this.ngAfterViewInit();
    }
  }

  constructor(private service: ParticipationDataService, private changeDetect: ChangeDetectorRef) {
  }

  ngOnInit() {

    if (this.questions == null) {
      this.questions = JSON.parse(this.JsonData);

      let fstQn = this.questions[0];
      if (fstQn != undefined && fstQn != null) {
        this.firstQuestion = fstQn;
      }

      let imgQn = this.questions.find(e => e.sub_qno == 1);
      if (imgQn != undefined && imgQn != null) {
        this.imgQuestion = imgQn;
      }
      if (this.group.answer_style == 1) {
        this.questions = CommonLogic.RandomQuestionsHandling(this.questions);
      }
      else if(this.group.answer_style == 0 && this.questions.length > 1)
      {
      this.questions.sort((n1, n2) => n1.sub_qno - n2.sub_qno);
      }
      else if(this.group.answer_style == 2 && this.questions[0].grpRotateIndex != -1 && this.questions.length > 1)
      {
        this.questions.sort((n1, n2) => n1.sub_qno - n2.sub_qno);
        CommonLogic.RotateQuestionsHandling(this.questions);
      }
      let mandatoryQuestion = this.questions.filter(e => e.mandatory);

      if (mandatoryQuestion != undefined && mandatoryQuestion != null) {
        if (mandatoryQuestion.length == this.questions.length) {
          this.isMandatory = true;
          this._isMandatoryInvalid = true;
        }
      }

      if (this.questions.length == 1) {
        this.isDisplaySubQNo = false;
      } else {
        this.isDisplaySubQNo = true;
      }
    }

    // Subscibe To Form Submit/Next Event ( Event is fired when mandatory is not satisfied )
    this.isFormSubmitSub = this.service.emitFormSubmitEvent.subscribe((data) => {
      this.isFormSubmit = data;
    });

    this.isPreview = this.service.GroupType.toUpperCase() == 'PREVIEW';
    this.isNewParticipation = this.service.isNewParticipation;
    this.surveyFormat = this.service.surveyFormat;
    this.newParticipationBtnText = this.service.newParticipationBtnText;
    this.showNewParticipationButton = (this.questions.length > 1 || !this.service.isAutoScroll) && this.isNewParticipationButton;
    this.isPreReadQn = this.questions.filter(e => e.population_type == 3).length>0;
  }

  ngAfterViewInit() {
    if(window.navigator.userAgent.indexOf("Chrome") != -1) {
      $('.answerParent').css('width', 'calc(100% + 1px)');
      // $('.question-option-wrapper').css('width', 'calc(100% + 1px)');
    }

    // var self = this;
    // $('document').ready(function () {
    //   for (let i = 0; i < self.questions.length; i++) {
    //     if ($("#lbltitle_R" + self.questions[i].UniqueNumber)) {
    //       for (let j = 0; j < self.questions[i].Answers.length; j++) {
    //         let radioid = "lbl_Q" + self.questions[i].qno + "_" + self.questions[i].UniqueNumber + "_R_" + self.questions[i].Answers[j].value_id + "_ID";
    //         $('#' + radioid).unbind().change(function (event) {
    //           if (self.questions[i].Answers[j].selectdId == 0) {
    //             $('#' + radioid).prop('checked', true);
    //             $('#' + radioid).next().addClass('selectedSymbol');
    //             self.ClickEventHandling(self.questions[i].Answers[j], self.questions[i]);
    //             self.SelectedValue(self.questions[i].Answers[j], self.questions[i]);
    //             // self.nextQuestion(event);
    //           }
    //           else {
    //             $('#' + radioid).prop('checked', false);
    //             $('#' + radioid).next().removeClass('selectedSymbol');
    //             self.ClickEventHandling(self.questions[i].Answers[j], self.questions[i]);
    //           }
    //         });
    //       }
    //     }
    //   }
    //   $('.symbol-wrapper').each(function () {
    //     $(this).attr('symbol-count', $(this).find('.answer-option').length);
    //   });
    // });

    var self = this;

    let elemid = '#dv_' + self.firstQuestion.UniqueNumber;

    var srsQuesWidth = 0;

    this.setLabelWidth(elemid);
    this.resetPageSub = this.service.emitResetPageEvent.subscribe((data) => {
      if(data) {
        this.isAnsChange =false;
      }
    });
  }

  ngOnDestroy() {
    this.isFormSubmitSub.unsubscribe();
    if (this.resetPageSub) {
      this.resetPageSub.unsubscribe();
    }
  }

  ngOnChangesEventHandle(no: number) {
    if (no == this.questions.length - 1) {
        this.ngAfterViewInit();
        this.count++;
    }
  }

  UpdateQuestionsData(question: Questions) {
    this.isAnsChange = true;
    this.ChangeAnswersData.emit(question);
  }

  GetQuestionsString(question): string {
    return JSON.stringify(question);
  }

  GetAnswerImages(question: Questions): AnswerImage[] {
    if (question.Answers[0].AnswerImages != null) {
      return question.Answers[0].AnswerImages;
    }
  }

  GetAnswerMedias(question: Questions): AnswerMedia[] {
    if (question.Answers[0].AnswerMedias != null) {
      return question.Answers[0].AnswerMedias;
    }
  }

  clickEventHandle(answer: Answers, question: Questions,event) {
    if (answer.selectdId == 0) {
      this.SelectedValue(answer, question);
    } else {
      this.ClickEventHandling(answer, question);
    }
    this.nextQuestion(event);
  }

  SelectedValue(answer: Answers, question: Questions) {
    if (question.Answers != null) {
      for (let i = 0; i < question.Answers.length; i++) {
        if (answer.ms_id === question.Answers[i].ms_id) {
          answer.selectdId = 1;
          answer.ControlAns = answer.value_id;
          question.Answers[i] = answer;
          question.AnswerID = answer.ms_id;
          question.selectAnsValue = answer.value_id;
          question.AnswerText = answer.ControlAns;
          question.pageto = answer.pageto;
          question.otherAnswer = null;

          if (question.isSoftRequired) {
            question.isSoftRequiredHandle = true;
          }

          if (answer.isOther) {
            question.isOtherAnswer = true;
          }
          else {
            question.isOtherAnswer = false;
          }
        }
        else {
          question.Answers[i].ControlAns = null;
          question.Answers[i].selectdId = 0;
        }
      }
      this.changeDetect.detectChanges();
      //this.ChangeAnswersData.emit(question);
      this.UpdateQuestionsData(question);
    }
  }

  ClickEventHandling(answer: Answers, question: Questions) {
    if (answer.selectdId == 0) {
      return;
    }

    if (question.Answers != null) {
      answer.selectdId = 0;
      answer.ControlAns = null;
      let updateItem = question.Answers.find(e => e.ms_id == answer.ms_id);
      let index = question.Answers.indexOf(updateItem);
      question.Answers[index] = answer;
      question.AnswerID = 0;
      question.selectAnsValue = 0;
      question.pageto = 0;
      question.AnswerText = null;
      question.otherAnswer = null;
      question.isOtherAnswer = false;
      //this.ChangeAnswersData.emit(question);
      this.UpdateQuestionsData(question);

      if (question.isSoftRequired) {
        question.isSoftRequiredHandle = false;
      }
      this.changeDetect.detectChanges();
      //this.ChangeAnswersData.emit(question);
      this.UpdateQuestionsData(question);
    }
  }

  getPipingTitle(group_no: number): string {
    return this.service.getPiping(group_no);
  }

  getHiddenQuestions(questions: Questions, service: ParticipationDataService) {
    if (service.getGroupType().toLowerCase() == "preview" && service.getPreviewData().isShowHiddenQN) {
      return true;
    }
    else {
      return (questions.population_type != 2 && questions.population_type != 5 && questions.isCQHide==false);
    }
  }

  nextQuestion(event) {
    if (this.service.isNewParticipation && (this.service.surveyFormat == 1 || this.service.surveyFormat == 2) && this.questions.length == 1 && this.service.isAutoScroll) {
      // var nextbtnLength = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').length;
      // if (nextbtnLength > 0) {
      //   var elemPosition = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').eq(0).offset().top;
      //   $('html,body').animate({
      //     scrollTop: (elemPosition - $(window).height() / 3)
      //   }, 400);
      // } else {
      //   var scrollVal = $('.tblPageFooter').offset().top;
      //   $('html,body').animate({
      //     scrollTop: scrollVal
      //   }, 400);
      // }

      this.service.gotoNextQuestion(this.questions[0],event);

    }
    else if (this.service.surveyFormat == 3 && this.questions.length == 1) {
      var currElem = $('.active-ques');
      var nextElem = currElem.nextAll('.inactive-ques').has('.question-data').eq(0);
      var afterNextElem = currElem.nextAll('.inactive-ques').has('.question-data').eq(1);
      if (nextElem.length > 0) {
        $('.back-arrow').removeClass('disabled');
        this.service.hideQuestion(currElem[0]);
        let isHidden = $(nextElem).find(".question-data").attr("hidden");

        if (isHidden) {
          this.service.showQuestion(afterNextElem[0]);
        } else {
          this.service.showQuestion(nextElem[0]);
        }

        if (afterNextElem.length == 0 && $('.next-button').length == 0) {
          $('.next-arrow').addClass('disabled');
        }
      } else {
        if ($('.next-button').length != 0) {
          $('.next-button').trigger('click');
        }
      }
    }
  }

  getAnsImageCSS() {
    if (this.questions.filter(e => e.Answers[0].hasImage || e.Answers[0].hasMedia).length == 0) {
      return '';
    } else{
      return 'hasImage';
    }
  }

  trackByUniqueNumber(index: number, question: Questions): string {
    return question.UniqueNumber.toString();
  }

  trackByValueId(index: number, answers: Answers): string{
    return answers.value_id + answers.zarca_q_id.toString();
  }

  gotoNextQuestion(question: Questions, event) {
    this.service.gotoNextQuestion(question, event) ;
  }

  setLabelWidth(elemid) {
    var srsQuesWidth = 0;
    var srsQuesMinWidth = 0;

    $(elemid).find('.srs-question').each(function() {
      if($(this).outerWidth() > srsQuesWidth) {
        srsQuesWidth = $(this).outerWidth();
        srsQuesMinWidth = ($(this).outerWidth() + 10);
      }
    });

    if(srsQuesWidth > 220) {
      srsQuesWidth = 220;
    }

    if(srsQuesMinWidth > 220) {
      srsQuesMinWidth = 220;
    }

    //$(elemid).find('.srs-question').css('width', srsQuesWidth + 'px');
    $(elemid).find('.srs-question').css('min-width', srsQuesMinWidth + 'px');
    $(elemid).find('.srs-question').css('white-space', 'normal');
  }

  gotoNextQuestionKeyboard(question,event) {
    event.preventDefault();
    this.gotoNextQuestion(question,event.target);
  }
  getTrimString(strValue:number)
  {
    debugger;
    return strValue.toString().trim();
  }
}
